export default {
  isLogin: state => state.userInfo.id
}
